import React from "react";
import { Switch, Route } from "react-router-dom";
import List from "./List";

function TiepWastage({ match }) {
  const { path } = match;
  console.log(path);
  return (
    <Switch>
      <Route exact path={`${path}`} component={List} />
    </Switch>
  );
}

export { TiepWastage };
